type ScratchIconName =
  | "hand"
  | "column"
  | "board"
  | "expand"
  | "collapse"
  | "pen"
  | "line"
  | "ellipse"
  | "text"
  | "erase";

export function ScratchIcon({ name }: { name: ScratchIconName }) {
  const common = {
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 1.8,
    strokeLinecap: "round" as const,
    strokeLinejoin: "round" as const,
  };

  return (
    <svg className="scratch-icon" viewBox="0 0 24 24" aria-hidden="true">
      {name === "hand" ? (
        <>
          <path {...common} d="m4 19 3.5-1 10-10-2.5-2.5-10 10L4 19Z" />
          <path {...common} d="m13.5 7 2.5 2.5M4 19h6" />
        </>
      ) : null}
      {name === "column" ? (
        <>
          <path {...common} d="M6 4h4M6 9h4M6 14h4M14 4h4M14 9h4M14 14h4M5 19h14" />
          <path {...common} d="M12 3v13" strokeDasharray="2 2" />
        </>
      ) : null}
      {name === "board" ? (
        <>
          <rect {...common} x="3" y="4" width="18" height="13" rx="1.5" />
          <path {...common} d="M8 21h8M10 17l-1 4M14 17l1 4M7 13l3-3 2 2 4-5" />
        </>
      ) : null}
      {name === "expand" ? (
        <path {...common} d="M9 4H4v5M15 4h5v5M9 20H4v-5M15 20h5v-5" />
      ) : null}
      {name === "collapse" ? (
        <path {...common} d="M4 9h5V4M20 9h-5V4M4 15h5v5M20 15h-5v5" />
      ) : null}
      {name === "pen" ? (
        <>
          <path {...common} d="m4 20 4.5-1 10-10-3.5-3.5-10 10L4 20Z" />
          <path {...common} d="m13.5 7 3.5 3.5" />
        </>
      ) : null}
      {name === "line" ? <path {...common} d="M5 18 19 6" /> : null}
      {name === "ellipse" ? <ellipse {...common} cx="12" cy="12" rx="8" ry="5" /> : null}
      {name === "text" ? (
        <path {...common} d="M5 6h14M12 6v13M8.5 19h7" />
      ) : null}
      {name === "erase" ? (
        <>
          <path {...common} d="m4 15 8.5-10L20 11.5 13.5 19H7L4 16Z" />
          <path {...common} d="m10 19 7-10" />
        </>
      ) : null}
    </svg>
  );
}
